export function PrivilegedViewBanner() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 12px',
        background: '#fffbeb',
        borderBottom: '1px solid #fcd34d',
        fontSize: 11,
        fontWeight: 600,
        color: '#92400e',
        letterSpacing: '0.01em',
        flexShrink: 0,
      }}
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      Privileged view — all reserved slots visible
    </div>
  );
}
